<template>
  <div class="bg">
    <!-- Asia is Our Base -->
    <div class="base">
      <div class="text">
        <div class="title">Asia is Our Base</div>
        <div class="value">Covering 14 countries & markets, with population over 10 million people, Holden supports our clients by carrying out research studies in the region. Our proprietary panels plus APPA panels are ready for easy access to local HCP physicians, patients and consumers
        </div>
      </div>
    </div>

    <!-- map -->
    <asia-map />

    <!-- Our Solutions -->
    <div class="solutions">
      <div class="bigtitle">Services</div>
      <!-- 左边图片 -->
      <div class="value">
        <div class=" d-none d-sm-block solutionsImg">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/solutions.jpg">
        </div>
        <!-- 右边文字 -->
        <div class="solutionsValue">
          <div class="oneBox solutionbox">
            <i class="el-icon-s-order " />
            <div class="text">
              <span>Qualitative Research</span>
              <div>321</div>
            </div>
          </div>
          <div class="twoBox solutionbox">
            <i class="el-icon-s-data" />
            <div class="text">
              <span>Quantitative Research</span>
              <div>1695</div>
            </div>
          </div>
          <div class="threeBox solutionbox">
            <i class="el-icon-s-claim " />
            <div class="text">
              <span>Research & Analytics</span>
              <div>884</div>
            </div>
          </div>
          <div class="fourBox solutionbox">
            <i class="el-icon-s-management" />
            <div class="text">
              <span>AI Assisted Transcription</br> & Summary</span>
              <div>1096</div>
            </div>
          </div>
        </div>
      </div>
      <div class="annotation" style="float:right;color:#7e6a6c">* Based on project data as of December 31,2022</div>
    </div>

    <!-- We get things Done -->
    <div class="things">
      <div class="title">Project Management</div>
      <div class="value">
        <div class="left">
          <div><span class="d-block d-sm-none">√</span> International Experience Local Expertise</div>
          <div><span class="d-block d-sm-none">√</span> Dedicated Project Manager Single Contact Point</div>
        </div>
        <div class="d-none d-sm-block"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/speed.jpg" alt=""></div>
        <div class="right">
          <div><span class="d-block d-sm-none">√</span> 18-Hours Work Clock</div>
          <div><span class="d-block d-sm-none">√</span> Speed+ | Quality, Coverage & Insight</div>

        </div>
      </div>

    </div>

    <!-- Qualitative Consultants -->
    <div class="Consultants">
      <div class="img">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/others/consultants.jpg" class="one">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/others/consultants2.jpg" class="two">

      </div>
      <div class="text">
        <div class="title">Research Consultants</div>
        <div class="value">Meet <a @click="btn('/team?source=asiaAccess')">our consultants</a> who can give you our advices on project design and execution in regard to your study in local market
        </div>
      </div>
    </div>

    <!-- Download our Panel Book -->
    <down-load />

  </div>

</template>

<script>
import { panelDownloads, getNewsList, advertisementFlow } from "@/api/api";
import DownLoad from "@/components/downLoad";
import AsiaMap from "@/components/asiaMap";

export default {
  data() {
    return {
      downloadfile: "",
      url: "",
      isshow: true,
      downloadid: ""
    };
  },
  components: { DownLoad, AsiaMap },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "asiaAccess",
          source: "",
          information: "Asia页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "asiaAccess",
          source: this.$route.query.source,
          information: "Asia页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    btn(path) {
      // 跳转页面
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.base {
  background-color: #fff;
  padding: 80px 120px;
  position: relative;
  overflow: hidden;
  .text {
    .title {
      font-size: 40px;
      font-weight: 700;
      color: #0cb4ec;
    }
    .value {
      color: #62778c;
      font-size: 23px;
      text-align: center;
      padding: 50px;
      font-weight: 700;
    }
  }
}

.solutions {
  background-color: #fff;
  padding: 80px 120px;
  .bigtitle {
    font-size: 40px;
    font-weight: 700;
    color: #0cb4ec;
  }
  .title {
    font-size: 40px;
    font-weight: 700;
    color: #0cb4ec;
  }
  .value {
    display: flex;
    justify-content: space-between;
    padding-top: 50px;
    .solutionsImg {
      // text-align: center;
      width: 35%;
      img {
        width: 100%;
      }
    }
    .solutionsValue {
      .text {
        span {
          font-weight: 700;
        }
        div {
        }
      }
      display: flex;
      flex-wrap: wrap;
      width: 65%;
      margin-left: 30px;
      .oneBox {
        width: 50%;
        padding-left: 20px;
        border-right: 1px solid #d5dbe5;
        border-bottom: 1px solid #d5dbe5;
      }
      .twoBox {
        width: 50%;
        padding-left: 20px;
        border-left: 1px solid #d5dbe5;
        border-bottom: 1px solid #d5dbe5;
      }
      .threeBox {
        width: 50%;
        padding-left: 20px;
        border-right: 1px solid #d5dbe5;
        border-top: 1px solid #d5dbe5;
      }
      .fourBox {
        width: 50%;
        padding-left: 20px;
        border-left: 1px solid #d5dbe5;
        border-top: 1px solid #d5dbe5;
      }
      .text {
        span {
          color: #108abe;
        }
        div {
          margin-top: 14px;
        }
      }
      font-size: 23px;
    }
  }
}
i {
  color: #2cb1e9;
  font-size: 40px;
}

.things {
  padding: 80px 120px;
  background-color: #2cb1e9;
  .title {
    font-size: 40px;
    font-weight: 700;
    color: #003c50;
  }
  .value {
    padding-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    // text-align: center;
    .left,
    .right {
      width: 32%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      div {
      }
    }
    .left {
      text-align: right;
    }
    img {
      width: 280px;
      height: 240px;
      border-radius: 50%;
    }
  }
}
.Consultants {
  display: flex;
  padding: 80px 120px 120px;
  position: relative;
  overflow: hidden;
  background-color: #e8eaed;
  .img {
    width: 50%;

    .one {
      position: absolute;
      left: 0;
      top: -40px;
      width: 400px;
      border-radius: 50%;
      border: 6px dotted #f56c6c;
    }
    .two {
      position: absolute;
      top: 230px;
      left: 350px;
      width: 350px;
      border-radius: 20%;
      border: 6px dotted #f56c6c;
    }
  }
  .text {
    width: 50%;
    .title {
      font-size: 40px;
      font-weight: 700;
      color: #f56c6c;
    }
    .value {
      font-size: 23px;
      font-weight: 700;
      // text-align: center;
      padding: 50px;
      color: #003c50;
      a {
        font-size: 30px;
        color: #f56c6c;
        text-decoration: underline;
        &:hover {
          color: #ff0000;
        }
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .base {
    .text {
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }

  .solutions {
    height: 1500px;
    .bigtitle {
      font-size: 80px;
    }
    .annotation {
      font-size: 55px;
    }
    .title {
      font-size: 70px;
    }
    .value {
      display: block;
      .solutionsValue {
        width: 100%;
        .solutionbox {
          padding: 20px;
          // width: 100%;
        }

        .text {
          span {
            font-size: 70px;
          }
          div {
            font-size: 70px;
          }
        }
      }
    }
  }
  i {
    font-size: 100px;
  }
  .things {
    .title {
      font-size: 80px;
    }
    .value {
      font-size: 70px;
      .d-block {
        display: inline-block !important;
      }
      .left,
      .right {
        width: 100%;
        div {
          margin-top: 60px;
        }
      }
      .left {
        text-align: left;
      }
    }
  }
  .Consultants {
    display: block;
    .img {
      width: 100%;
      .one {
        width: 800px;
      }
      .two {
        width: 700px;
        top: 500px;
        left: 700px;
      }
    }
    .text {
      width: 100%;
      padding-top: 1000px;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
        a {
          font-size: 75px;
        }
      }
    }
  }
}
</style>
